<ng-container *ngComponentOutlet="sidebarInput.component; injector: sidebarInput.injector" />
